import { CookieService } from '../cookie-service';
import { IPAddressService } from '../ip-address-service';

export const isImpersonating = () => CookieService.getCookieValue('x-imp');

/**
 * Returns whether or not the Jest runner is executing things {@link https://jestjs.io/docs/environment-variables}
 * @returns {boolean}
 */
export const isInJestRunnerMode = () => process.env.NODE_ENV === 'test';

const sellerHasUpsAccount = (labelProviders) => {
  const UPS_OB_PROVIDERID = '103';
  const UPS_PROVIDERID = '3';
  return labelProviders.some((labelProvider) => {
    return [UPS_OB_PROVIDERID, UPS_PROVIDERID].includes(labelProvider.labelProviderId);
  });
};

export const buildIdentifyTraits = (sellerId, userInfo, sellerInfo) => {
  return {
    sellerId,
    groupId: sellerId,
    userId: userInfo.userId,
    email: userInfo.email,
    createDate: userInfo.createDate,
    name: userInfo.name,
    username: userInfo.username,
    currentUIVersion: userInfo.currentUIVersion,
    version: 'V3',
    clientIpAddress: IPAddressService.ipAddress,
    company: sellerInfo.companyName,
    restrictions: userInfo.restrictions,
    roles: userInfo.roles,
  };
};

export const buildGroupTraits = (sellerId, sellerInfo) => {
  const environment = window.SS_GLOBALS.frontEndConfig.serverEnv ? `${window.SS_GLOBALS.frontEndConfig.serverEnv}` : undefined;

  return {
    sellerId,
    environment,
    homeCountry: sellerInfo.homeCountry,
    isNativeV3Seller: sellerInfo.isNativeV3Seller,
    minimumVersion: sellerInfo.minimumVersion,
    planName: sellerInfo.planName,
    earlyAccessEnabled: sellerInfo.earlyAccessEnabled,
    hasUPSAccount: sellerHasUpsAccount(sellerInfo.labelProviders),
  };
};
